module.exports = __webpack_public_path__ + "static/media/img-booking-notAvailable.f1421e93.svg";